export class AwsSourceServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ec2",
            "baseName": "ec2",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shovalAgent",
            "baseName": "shovalAgent",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "rds",
            "baseName": "rds",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3",
            "baseName": "s3",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dynamodb",
            "baseName": "dynamodb",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eks",
            "baseName": "eks",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eksNamespaces",
            "baseName": "eksNamespaces",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "fsx",
            "baseName": "fsx",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "efs",
            "baseName": "efs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "documentdb",
            "baseName": "documentdb",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "neptune",
            "baseName": "neptune",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "keyspaces",
            "baseName": "keyspaces",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "opensearch",
            "baseName": "opensearch",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ec2Discovery",
            "baseName": "ec2Discovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "rdsDiscovery",
            "baseName": "rdsDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3Discovery",
            "baseName": "s3Discovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dynamodbDiscovery",
            "baseName": "dynamodbDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eksDiscovery",
            "baseName": "eksDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "fsxDiscovery",
            "baseName": "fsxDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "efsDiscovery",
            "baseName": "efsDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "documentdbDiscovery",
            "baseName": "documentdbDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "neptuneDiscovery",
            "baseName": "neptuneDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "keyspacesDiscovery",
            "baseName": "keyspacesDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "opensearchDiscovery",
            "baseName": "opensearchDiscovery",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSourceServices.attributeTypeMap;
    }
    constructor() {
    }
}
